module.exports = __webpack_public_path__ + "img/colaborador-jonatas-de-novaes-amarim.af8e6aca.jpeg";